import React, { useRef, useEffect } from 'react';
import cx from 'classnames';
import '../../../ui/accordions/Accordion/index.js';
import '../../../ui/accordions/AccordionSelect/index.js';
import '../../../ui/badges/Badge/index.js';
import '../../../ui/badges/BadgeIcon/index.js';
import '../../../ui/badges/Checked/index.js';
import '../../../ui/badges/Panel/index.js';
import '../../../ui/badges/Status/index.js';
import '../../../ui/badges/Tag/index.js';
import '../../../ui/buttons/BabyButton/Base.js';
import '../../../ui/buttons/BabyButton/variants/Chat/index.js';
import '../../../ui/buttons/BabyButton/variants/Menu/index.js';
import '../../../ui/buttons/BabyButton/variants/User/index.js';
import '../../../ui/buttons/BabyButton/variants/Vip/index.js';
import '../../../ui/buttons/BabyButton/variants/Wallet/index.js';
import '../../../ui/buttons/Button/index.js';
import '../../../ui/buttons/CloseButton/index.js';
import '../../../ui/buttons/DirectionButton/index.js';
import { GradientButton } from '../../../ui/buttons/GradientButton/index.js';
import '../../../ui/buttons/GradientButtonV2/index.js';
import '../../../ui/buttons/TabButton/index.js';
import '../../../ui/buttons/TabButtonV2/index.js';
import '../../../ui/buttons/TimerButton/index.js';
import '../../../ui/buttons/TimerButtonV2/index.js';
import '../../../ui/buttons/TimerButtonV3/index.js';
import '../../../ui/loaders/Loader/index.js';
import '../../../ui/loaders/ScreenLoader/index.js';
import { ModalComponent } from '../../../ui/modals/Modal/index.js';
import '../../../ui/popups/Popper/index.js';
import '../../../ui/popups/Popup/BasePopup/index.js';
import '../../../ui/popups/Popup/Thumb/index.js';
import '../../../ui/popups/Popup/ThumbV2/index.js';
import '../../../ui/popups/Popup/InfoTooltip/index.js';
import '../../../ui/sliders/EmblaCarousel/index.js';
import '../../../ui/tables/Table/index.js';
import '../../../ui/tables/Table/TableTd/index.js';
import '../../../ui/tabs/Tabs/index.js';
import '../../../ui/tabs/TabsV2/index.js';
import '../../../ui/texts/CryptoValue/index.js';
import '../../../ui/texts/AmountValue/index.js';
import '../../../ui/texts/TitleWithCurrency/index.js';
import '../../../ui/texts/Text/index.js';
import '../../../ui/texts/TextNavigation/index.js';
import '../../../ui/texts/MinValue/index.js';
import '../../../ui/socials/SocialsList/index.js';
import { useWindowSize } from '../../../../utils/hooks/useWindowSize.js';
import { DEFAULT_BOTTOM_MODAL_STYLE_CONFIG } from '../../../ui/modals/Modal/config/index.js';
import Coin from '../../../../static/cookie/coin.png.js';
import styles from './index.module.scss.js';

const CookieModal = ({
  isOpen,
  onClose,
  afterOpenModal = () => {
  },
  onAfterClose = () => {
  },
  text = {
    title: "This website use cookies",
    description: "Housebets uses cookies to improve performance, remember preferences, and show relevant offers. By using our site, you agree to this.",
    button: "Accept All"
  }
}) => {
  const { isMobile } = useWindowSize();
  const inputSearchRef = useRef(null);
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        if (inputSearchRef) {
          inputSearchRef?.current?.focus();
        }
      });
    }
  }, [isOpen]);
  return /* @__PURE__ */ React.createElement(
    ModalComponent.Modal,
    {
      modalIsOpen: isOpen,
      closeModal: () => {
      },
      hideCloseButton: true,
      bottom: true,
      afterOpenModal,
      onAfterClose,
      blockPageScroll: false,
      overlayTransparent: true,
      configuration: isMobile ? {
        ...DEFAULT_BOTTOM_MODAL_STYLE_CONFIG(),
        overlay: {
          height: "100vh",
          background: "transparent",
          pointerEvents: "none",
          // zIndex: 'unset',
          zIndex: 99
        },
        content: {
          height: "100dvh",
          width: "100%",
          maxHeight: "100dvh",
          maxWidth: "100% !important",
          overflow: isMobile ? "auto" : "visible",
          background: "transparent",
          boxShadow: "unset",
          padding: 0,
          borderRadius: 12,
          transform: "unset !important",
          marginRight: "unset !important",
          inset: "unset",
          pointerEvents: "none"
        },
        childrenWrapper: {
          borderRadius: 0,
          overflow: "visible",
          background: "linear-gradient(180deg, #122227 -66.87%, #081519 50%)",
          border: "1px solid rgba(8, 51, 60, 1)",
          position: "absolute",
          bottom: 0,
          width: "100%",
          height: "auto",
          borderBottom: "unset",
          borderRight: "unset",
          borderLeft: "unset",
          pointerEvents: "auto"
        }
      } : {
        overlay: {
          background: "transparent",
          pointerEvents: "none",
          zIndex: "unset",
          display: "flex",
          justifyContent: "center"
        },
        content: {
          height: "100%",
          width: "100%",
          maxHeight: "100%",
          // maxWidth: '1580px',
          maxWidth: "100%",
          overflow: isMobile ? "auto" : "visible",
          background: "transparent",
          boxShadow: "unset",
          padding: 0,
          borderRadius: 12,
          transform: "unset !important",
          marginRight: "unset !important",
          inset: "unset",
          pointerEvents: "none"
        },
        childrenWrapper: {
          overflow: "visible",
          // background: '#051215',
          background: "linear-gradient(180deg, #122227 -66.87%, #081519 50%)",
          border: "1px solid rgba(8, 51, 60, 1)",
          position: "absolute",
          bottom: 16,
          right: 35,
          width: "564px",
          height: 234,
          pointerEvents: "auto"
        }
      }
    },
    /* @__PURE__ */ React.createElement("div", { className: cx(styles.box) }, /* @__PURE__ */ React.createElement("div", { className: styles["box-left"] }, /* @__PURE__ */ React.createElement("img", { alt: "cookie", src: Coin })), /* @__PURE__ */ React.createElement("div", { className: styles["box-right"] }, /* @__PURE__ */ React.createElement("div", { className: styles["box-right__title"] }, text.title), /* @__PURE__ */ React.createElement("div", { className: styles["box-right__description"] }, text.description), /* @__PURE__ */ React.createElement("div", { className: styles["box-right__button"] }, /* @__PURE__ */ React.createElement(
      GradientButton,
      {
        kind: "fill",
        size: "small-2",
        text: text.button,
        onClick: onClose
      }
    ))))
  );
};

export { CookieModal };
//# sourceMappingURL=index.js.map
